import type { IconSvgObject } from './types';

const PanelTopBottomDashedIcon: IconSvgObject = [
  ["path", { d: "M3.50003 9H4.99997M8.99997 9H9.99997M14 9H15M19 9H20.5M3.50003 15H4.99997M8.99997 15H9.99997M14 15H15M19 15H20.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 21H12H12C16.2427 21 18.364 21 19.682 19.682C21 18.364 21 16.2426 21 12V12V12C21 7.75735 21 5.63604 19.682 4.31802C18.364 3 16.2427 3 12 3C7.75739 3 5.63607 3 4.31805 4.31802C3.00003 5.63604 3.00003 7.75736 3.00003 12C3.00003 16.2426 3.00003 18.364 4.31805 19.682C5.63607 21 7.75738 21 12 21Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default PanelTopBottomDashedIcon;
